import { render, staticRenderFns } from "./CIOverview.vue?vue&type=template&id=cf06ad30&scoped=true"
import script from "./CIOverview.vue?vue&type=script&lang=js"
export * from "./CIOverview.vue?vue&type=script&lang=js"
import style0 from "./CIOverview.vue?vue&type=style&index=0&id=cf06ad30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf06ad30",
  null
  
)

export default component.exports